export default "__VITE_ASSET__CiX5$c6M__"